// useImageUris.js

import { useEffect, useState } from 'react';

const useImageUris = (guideList) => {
  const [imageUris, setImageUris] = useState({});

  useEffect(() => {
    const fetchImageUris = async () => {
      const imageUrisObject = {};
      for (const guide of guideList) {
        const imagePath = `./thumbnail/${guide.img}.png`;
        try {
          const dataUri = await getImageDataURI(imagePath);
          imageUrisObject[guide.id] = dataUri;
        } catch (error) {
          console.error('Error loading image:', error);
        }
      }
      setImageUris(imageUrisObject);
    };

    fetchImageUris();
  }, [guideList]);

  return imageUris;
};

const getImageDataURI = async (path) => {
  const xhr = new XMLHttpRequest();
  xhr.open('GET', path, true);
  xhr.responseType = 'arraybuffer';

  return new Promise((resolve, reject) => {
    xhr.onload = () => {
      if (xhr.status === 200) {
        const base64 = btoa(
          new Uint8Array(xhr.response).reduce(
            (data, byte) => data + String.fromCharCode(byte),
            ''
          )
        );
        resolve(`data:image/png;base64,${base64}`);
      } else {
        reject(xhr.statusText);
      }
    };

    xhr.onerror = () => reject(xhr.statusText);
    xhr.send();
  });
};

export default useImageUris;
